import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import ExecutiveOverview from "@/pages/ExecutiveOverview";
import Memorandum from "@/pages/Memorandum";
import ValueCreation from "@/pages/ValueCreation";
import FinancialIntelligence from "@/pages/FinancialIntelligence";
import Operations from "@/pages/Operations";
import Workforce from "@/pages/Workforce";
import Geological from "@/pages/Geological";
import GeoEsgIntelligence from "@/pages/GeoEsgIntelligence";
import RegionalContext from "@/pages/RegionalContext";
import Financial from "@/pages/Financial";
import Legal from "@/pages/Legal";
import RiskInsights from "@/pages/RiskInsights";
import DataRoom from "@/pages/DataRoom";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Navigate to="/overview" replace />} />
            <Route path="overview" element={<ExecutiveOverview />} />
            <Route path="memorandum" element={<Memorandum />} />
            <Route path="value-creation" element={<ValueCreation />} />
            <Route path="financial-intelligence" element={<FinancialIntelligence />} />
            <Route path="operations" element={<Operations />} />
            <Route path="workforce" element={<Workforce />} />
            <Route path="geological" element={<Geological />} />
            <Route path="geo-esg" element={<GeoEsgIntelligence />} />
            <Route path="regional" element={<RegionalContext />} />
            <Route path="financial" element={<Financial />} />
            <Route path="legal" element={<Legal />} />
            <Route path="risk" element={<RiskInsights />} />
            <Route path="data-room" element={<DataRoom />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </div>
  );
}

export default App;
